import { Injectable, Inject } from '@angular/core';

export class PolicyAdditionalFieldDO {

	public id: Number;
	public fieldKey: String;
	public fieldValue: String;
	public parentObject: any
	public versionId: any
	public guid: any
	public createdDt: any
	public updatedDt: any
	public createdUser: any
	public updatedUser: any
	public caseManager: any
	public objectName: any

	public getId(): Number {
		return this.id;
	}

}
